import { AppEnvType, DeployArea, IAppConfig } from '../model';
import { LanguageType } from '../lib/language';

const config: IAppConfig = {
  env: AppEnvType.Development,
  appID: 'intl-gcloud',
  userID: '-',
  consoleURL: '',
  userURL: '',
  websiteURL: '',
  supportURL: '',
  woaContactPerson: '',
  devPerson: [],
  portalLastVersionUpdateTime: {
    zh_CN: '2025年1月17日11',
    en_US: 'January 17, 2025.11',
  },
  copyRight: {
    copyRightText: '',
    protocolLinks: {},
  },
  deployArea: DeployArea.singapore,
  gameConfig: {
    region: [],
  },
  cookieName: 'INTL_GCLOUD_TICKET',
  aegisConfig: {
    enable: false,
    id: '',
    hostUrl: '',
  },
  // document: {
  //   consoleHelperLinks: {
  //     en_US: [
  //       {
  //         label: '',
  //         url: '',
  //       },
  //     ],
  //     zh_CN: [
  //       {
  //         label: '',
  //         url: '',
  //       },
  //     ],
  //   },
  // },
  documentConfig: {
    modules: [],
    consoleHelperLinks: {
      en_US: [],
      zh_CN: [],
    },
  },
  // helperIconLink: '/doc/detail/35',
  legalTerms: {
    enabledCookieTips: false,
    dataTransferProtocol: {
      enabled: false,
      url: '',
      label: '',
    },
    privacyPolicyProtocol: {
      enabled: false,
      url: '',
      label: '',
    },
    termsOfServiceProtocol: {
      enabled: false,
      url: '',
      label: '',
    },
  },
  // docConfig: {
  //   projectID: [
  //     {
  //       en_US: 38,
  //       zh_CN: 39,
  //     },
  //   ],
  // },
  languageConfig: {
    currentLanguage: 0,
    languageList: [
      {
        area: '',
        items: [
          {
            name: '',
            key: LanguageType.en_US,
            link: '',
          },
        ],
      },
    ],
  },
};
export default config;
